import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, "Тема:", -1)
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "ml-2",
  for: "stop_check_next_rules"
}, "Автоматически", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.auto_switch_theme,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.auto_switch_theme) = $event)),
          binary: true,
          inputId: "stop_check_next_rules"
        }, null, 8, ["modelValue"]),
        _hoisted_3
      ]),
      _createVNode(_component_Button, {
        disabled: !!_ctx.auto_switch_theme,
        class: "p-button-outlined mr-2",
        label: "Светлая",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTheme('light')))
      }, null, 8, ["disabled"]),
      _createVNode(_component_Button, {
        disabled: !!_ctx.auto_switch_theme,
        class: "p-button-outlined mr-2",
        label: "Темная",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTheme('dark')))
      }, null, 8, ["disabled"])
    ])
  ]))
}